<template>
	<div>
		<div class="InformationList" v-for="(item,index) of InformationArr" :key="index" @click="SeeInfo(item)">
			<!-- <div class="InformationTopTextNo">{{ item.Title }}</div> -->
			<!-- <div class="InformationTopText" v-if="item.state == 1">{{ item.Title }}</div>-->
			<div class="InformationTopTextAfter" v-if="item.IsView == 1">{{ item.Title }}</div>
			<div class="InformationTopTextNo" v-if="item.IsView == 0">{{ item.Title }}</div>
			<div class="center-Time center">{{ item.CreateTime }}</div>
			<div class="center-line  center">|</div>
			<div class="center-name center">{{ item.CreatorName }}</div>
			<div></div>
			<div class="InformationBottomText">{{ item.InfoContent }}</div>
			<div class="LookInfo" @click="SeeInfo(item)">查看详情</div>
			<div class="line"></div>
		</div>
	</div>
</template>

<script>
	export default {
		components: {},
		props: {
			InformationArr: {
				type: Array
			}
		},
		data() {
			return {

			}
		},
		created() {},
		mounted() {},
		activated() {},
		updated() {},
		methods: {
			SeeInfo(e) {
				if (e.OuterLinkUrl) {
					window.open(e.OuterLinkUrl)
				} else {
					let par = {
						InfoID: e.InfoID
					}
					this.$emit("SeeInfo", par)
				}
			}
		},
		computed: {},
		watch: {},
	}
</script>
<style scoped lang='less'>
	.InformationList {
		position: relative;

		.InformationTopText {
			width: 100%;
			height: 25px;
			display: block;
			margin-top: 33px;
			font-weight: bold;
			color: #e71d43;
			font-size: 20px;
			cursor: pointer;
			line-height: 25px;
			// border: 1px solid red;
		}

		.InformationTopTextAfter {
			width: 100%;
			height: 25px;
			display: block;
			margin-top: 33px;
			font-weight: bold;
			color: #9ca5b8;
			font-size: 20px;
			cursor: pointer;
			line-height: 25px;
			// border: 1px solid red;
		}

		.InformationTopTextAfter:hover {
			color: #e71d43;
		}

		.InformationTopTextNo {
			width: 100%;
			height: 25px;
			display: block;
			margin-top: 33px;
			font-weight: bold;
			color: #16181a;
			font-size: 20px;
			cursor: pointer;
			line-height: 25px;
			// border: 1px solid red;
		}

		.InformationTopTextNo:hover {
			color: #e71d43;
		}

		.center {
			font-size: 14px;
			color: #9ca5b8;
			display: inline-block;
			margin-top: 6px;
		}

		.center-line {
			margin-left: 8px;
		}

		.center-name {
			margin-left: 8px;
		}

		.InformationBottomText {
			position: relative;
			display: inline-block;
			max-width: 93%;
			// border: 1px solid red;
			font-weight: 400;
			color: #424e66;
			font-size: 14px;
			margin-top: 20px;
			/* 规定段落中的文本不进行换行： */
			white-space: nowrap;
			/* 内容会被修剪，并且其余内容是不可见的。 */
			overflow: hidden;
			/* 显示省略符号来代表被修剪的文本。 */
			text-overflow: ellipsis;
		}

		.LookInfo {
			display: inline-block;
			position: relative;
			left: 15px;
			bottom: 5px;
			padding-right: 20px;
			color: #9ca5b8;
			background: url("../../../../../../assets/channel/login/info.png") no-repeat 50px 1px;
		}

		.LookInfo:hover {
			cursor: pointer;
			color: #e71d43;
			background: url("../../../../../../assets/channel/login/info-red.png") no-repeat 50px 1px;
		}

		.line {
			width: 100%;
			height: 1px;
			background-color: #f2f3f5;
			margin-top: 32px;
		}
	}
</style>
